import { render, staticRenderFns } from "./SortItOut.vue?vue&type=template&id=381a643a&scoped=true"
import script from "./SortItOut.vue?vue&type=script&lang=js"
export * from "./SortItOut.vue?vue&type=script&lang=js"
import style0 from "./SortItOut.vue?vue&type=style&index=0&id=381a643a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381a643a",
  null
  
)

export default component.exports